<template>
    <div class="">
        <InfoPopup ref="rolesPopup">
            <RolesMultilanguage>
            </RolesMultilanguage>
        </InfoPopup>
        <div class="users-page-header col-12" v-if="company">
            <div class="col-4">
                Group name: <span>{{ company.name }}</span>
            </div>
            <div class="col-4">
                User count: <span :class="users.length >= company.max_number_of_users ? 'user-limit-full' : ''">{{
                    users.length
                }} / {{ company.max_number_of_users }}</span>
            </div>
        </div>

        <div class="row page-row users">

            <div class="d-flex justify-content-center mb-3" v-if="!company">
                <b-spinner label="Loading..." variant="danger"></b-spinner>
            </div>
            <div class="col-sm-12 pr-4" v-else>
                <b-button :disabled="!hasManagerPermission('projects.add_user')" variant="danger"
                          @click="showCreateUserModal" ref="btnShow"
                          v-if="company.max_number_of_users > users.length">
                    <b-icon icon="plus" variant="md"></b-icon>
                    Add User
                </b-button>
                <div v-else>
                    You have maxed out your user limit, please contact <a href="mailto:support@dotag.com">support@dotag.com</a>
                </div>


                <!--                <button class="btn btn-primary" data-toggle="modal" data-target="#noMorelicense">-->
                <!--                    No more license-->
                <!--                </button>-->
                <br/>
                <br/>
                <table class="table table-hover users">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">User</th>
                        <th scope="col">Role
                            <b-button variant="none" size="md" pill style="padding: 0;margin: 0;"
                                      @click="openRolesPopup">
                                <b-icon icon="info"
                                        class="rounded-circle bg-danger text-white text-decoration-none"></b-icon>
                            </b-button>
                        </th>
                        <th scope="col">Last updated</th>
                        <th class="col-6" scope="col">Assigned to</th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users" v-bind:key="user.id">
                        <th scope="row">{{ user.unique_id }}</th>
                        <td>{{ user.name }}</td>
                        <td>{{ user.role ? user.role.name : '-' }}</td>
                        <td>
                            <span class="last-updated" v-b-tooltip :title="user.updated_at">{{
                                    lastUpdated(user)
                                }}</span>
                        </td>
                        <td>
                            <span v-for="(project,index) in user.assigned_projects" v-bind:key="'p_' + index">
                                {{ project.name }}<span v-if="index !== user.assigned_projects.length - 1">, </span>
                            </span>
                        </td>
                        <!--                        <td><img src="../../../images/profile-placeholder.png" alt=""></td>-->
                        <td>
                            <button v-if="canEdit(user)" class="btn edit" @click="editUser(user)"></button>
                            <button v-if="canDelete(user)" class="btn delete" @click="confirmDeleteUser(user)"></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <!--                <p>Your account allows you to create 4 users. <a href="#">Upgrade your account HERE</a></p>-->
            </div>
            <!--<div class="col-sm-4 text-right">-->
            <!--                <div class="d-inline-block roles-hint">-->
            <!--                    <h3>Roles</h3>-->
            <!--                    <ul class="list-unstyled">-->
            <!--                        <li data-toggle="tooltip" data-html="true" title="<em>Tooltip</em> <u>with</u> <b>HTML</b>">-->
            <!--                            Admin-->
            <!--                        </li>-->
            <!--                        <li data-toggle="tooltip" data-html="true" title="<em>Tooltip</em> <u>with</u> <b>HTML</b>">-->
            <!--                            Manager User-->
            <!--                        </li>-->
            <!--                        <li data-toggle="tooltip" data-html="true" title="<em>Tooltip</em> <u>with</u> <b>HTML</b>">-->
            <!--                            Mobile User-->
            <!--                        </li>-->
            <!--                    </ul>-->
            <!--                </div>-->
            <!--</div>-->

            <b-modal id="remove-user-modal" centered size="lg"
                     :title="'Remove user'"
                     @ok="deleteUser">
                <p class="my-4">Are you sure you want to delete this user?</p>
            </b-modal>

            <user-modal :user="currentUser" :is-reseller="false" v-on:userSaved="closeEditUserModal"></user-modal>

            <!--            <b-modal id="create-user-modal" centered size="lg" @show="isCreateUserModalVisible = true"-->
            <!--                     @hidden="isCreateUserModalVisible = false"-->
            <!--                     :title="(currentUser && currentUser.id ? 'Edit user' : 'Create user') + ' (' + createUserStep + '/' + 2 + ')'"-->
            <!--                     @ok="saveUser">-->

            <!--                <template v-slot:default="{ hide }">-->
            <!--                    <div v-if="currentUser">-->


            <!--                        <div v-if="errors.length">-->
            <!--                            <b>Please correct the following error(s):</b>-->
            <!--                            <ul>-->
            <!--                                <li v-for="(error, index) in errors" v-bind:key="'e_' + index" v-html="error"></li>-->
            <!--                            </ul>-->
            <!--                        </div>-->


            <!--                        <div v-if="createUserStep === 1">-->

            <!--                            <div class="input-group mb-3">-->
            <!--                                <input type="text" placeholder="Unique ID" class="form-control" v-if="currentUser.id"-->
            <!--                                       disabled-->
            <!--                                       v-model="currentUser.unique_id">-->
            <!--                            </div>-->

            <!--                            <div class="input-group mb-3">-->
            <!--                                <input type="text" placeholder="Name" class="form-control" required-->
            <!--                                       v-model="currentUser.name">-->
            <!--                            </div>-->
            <!--                            <div class="input-group mb-3">-->
            <!--                                <input type="text" placeholder="Email" class="form-control" required-->
            <!--                                       v-model="currentUser.email">-->
            <!--                            </div>-->


            <!--                            <div class="input-group mb-3">-->
            <!--                                <verte v-if="isCreateUserModalVisible" :picker="'wheel'" model="rgb"-->
            <!--                                       v-model="currentUser.color" :model="'hex'" :enableAlpha="false"-->
            <!--                                       :rgbSliders="false"></verte>-->
            <!--                                &nbsp;-->
            <!--                                <input type="text" placeholder="Color" class="form-control" required-->
            <!--                                       v-model="currentUser.color" disabled/>-->
            <!--                            </div>-->

            <!--                            <div class="input-group mb-3">-->
            <!--                                <select :class="'form-control roleSelect' + (currentUser.role.id ? 'has-role' : '')"-->
            <!--                                        v-model="currentUser.role.id" required-->
            <!--                                        v-if="!currentUser.role || !currentUser.role.id || currentUser.role.id > 1"-->
            <!--                                        placeholder="Role">-->
            <!--                                    <option selected value="" disabled>Select role</option>-->
            <!--                                    <option v-if="role.id > 1" v-for="role in roles" v-bind:key="'r_' + role.id"-->
            <!--                                            :value="role.id">-->
            <!--                                        {{ role.name }}-->
            <!--                                    </option>-->
            <!--                                </select>-->
            <!--                            </div>-->

            <!--                            <template v-if="!currentUser.id || hasManagerPermission('profile.change_password')">-->

            <!--                                <p v-if="currentUser.id !== null">Leave the password empty if you don't want to-->
            <!--                                    change it</p>-->

            <!--                                <div class="input-group mb-3">-->
            <!--                                    <input type="password" placeholder="Password" class="form-control"-->
            <!--                                           :required="currentUser.id === null"-->
            <!--                                           v-model="currentUser.password">-->
            <!--                                </div>-->
            <!--                                <div class="input-group mb-3">-->
            <!--                                    <input type="password" placeholder="Confirm Password" class="form-control"-->
            <!--                                           :required="currentUser.id === null"-->
            <!--                                           v-model="currentUser.confirm_password">-->
            <!--                                </div>-->
            <!--                            </template>-->

            <!--                        </div>-->
            <!--                        <div v-if="createUserStep === 2">-->
            <!--                            <h4>Assigned projects</h4>-->
            <!--                            <div class="form-check" v-for="project in projects">-->
            <!--                                <input :id="'project_checkbox_' + project.id" class="form-check-input"-->
            <!--                                       type="checkbox" :value="project.id"-->
            <!--                                       :checked="currentUser.assigned_projects.filter(assigned_project => assigned_project.id === project.id).length > 0"-->
            <!--                                       :ref="'project_checkbox_' + project.id"-->
            <!--                                       @change="projectChange($event, project)"-->
            <!--                                >-->
            <!--                                <label class="form-check-label" :for="'project_checkbox_' + project.id">-->
            <!--                                    {{ project.name }}-->
            <!--                                </label>-->
            <!--                            </div>-->
            <!--                        </div>-->

            <!--                        &lt;!&ndash;                            <div class="custom-file">&ndash;&gt;-->
            <!--                        &lt;!&ndash;                                <input type="file" class="custom-file-input" id="customFile">&ndash;&gt;-->
            <!--                        &lt;!&ndash;                                <label class="custom-file-label" for="customFile">Add user image</label>&ndash;&gt;-->
            <!--                        &lt;!&ndash;                            </div>&ndash;&gt;-->

            <!--                    </div>-->
            <!--                </template>-->

            <!--                <template v-slot:modal-footer="{ ok, cancel, hide }">-->
            <!--                    &lt;!&ndash; Emulate built in modal footer ok and cancel button actions &ndash;&gt;-->

            <!--                    <b-button size="lg" variant="danger" @click="cancel()">-->
            <!--                        Close-->
            <!--                    </b-button>-->

            <!--                    <b-button size="lg" variant="outline-secondary" v-if="createUserStep === 1"-->
            <!--                              @click="createUserStep++">-->
            <!--                        Next-->
            <!--                    </b-button>-->
            <!--                    <b-button size="lg" variant="outline-secondary" v-if="createUserStep > 1" @click="createUserStep&#45;&#45;">-->
            <!--                        Previous-->
            <!--                    </b-button>-->

            <!--                    <b-button size="lg" variant="success" @click="ok()">-->
            <!--                        Save changes-->
            <!--                    </b-button>-->

            <!--                </template>-->
            <!--            </b-modal>-->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Verte from 'verte';
import 'verte/dist/verte.css';
import '@css/users.css';
import axios from "axios";
import UserModal from "../../reseller/components/Companies/Parts/UserModal";
import InfoPopup from '@components/common/PopupModal.vue';
import moment from "moment/moment";
import {cloneDeep} from "lodash";
import PrintPopup from "@components/common/PopupModal.vue";
import RolesMultilanguage from "@components/common/RolesMultilanguage.vue";

Vue.component('verte', Verte);

export default {
    components: {PrintPopup, UserModal, InfoPopup, RolesMultilanguage},
    comments: {Verte},
    data() {
        return {
            company: null,
            users: [],
            roles: [],
            projects: [],
            currentUser: {
                id: null,
                name: null,
                email: null,
                unique_id: null,
                color: null,
                password: null,
                confirm_password: null,
                role: {
                    id: '',
                    name: ''
                },
                assigned_projects: []
            },
            createUserStep: 1,
            errors: [],
            isCreateUserModalVisible: false,
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.loadCompany();
            this.loadCompanies();
            this.loadUsers();
            this.loadRoles();
            this.loadProjects();
        },
        loadCompany() {
            if (!this.$route.params.company_id) {
                return;
            }

            this.$store.state.company.id = this.$route.params.company_id;

            this.$store.dispatch('loadCompany').then((company) => {
                this.company = company;
            });
        },
        loadCompanies() {
            if (!this.$route.params.company_id) {
                return;
            }

            this.$store.dispatch('loadCompanies').then(companies => {
                this.$store.state.companies = companies;
            });
        },
        loadUsers() {
            if (!this.$route.params.company_id) {
                return;
            }
            this.$store.dispatch('loadUsers').then((users) => {
                this.users = users;
            });
        },
        loadRoles() {
            this.$store.dispatch('loadRoles').then((roles) => {
                this.roles = roles;
            });
        },
        loadProjects() {
            if (!this.$store.state.project.id) {
                return;
            }
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/projects',
                method: 'GET',
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.projects = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        showCreateUserModal() {
            this.createUserStep = 1;
            this.resetCurrentUser();

            this.$bvModal.show('userModal');

        },
        openRolesPopup() {
            this.$refs.rolesPopup.openPopup();
        },

        confirmDeleteUser(user) {
            this.currentUser = {...user};

            this.$bvModal.show('remove-user-modal');
        },
        deleteUser() {
            const token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/users/' + this.currentUser.id,
                method: 'DELETE',
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.$bvModal.hide('remove-user-modal');
                    this.load();
                })
                .catch(error => {
                    if (error.response?.data?.message) {
                        alert(error.response.data.message);
                    }

                    console.log(error);
                });
        },
        editUser(user) {
            this.createUserStep = 1;
            this.currentUser = {...user};
            this.currentUser.password = null;
            this.currentUser.confirm_password = null;

            this.$bvModal.show('userModal');
        },
        resetCurrentUser() {
            this.currentUser = {
                id: null,
                name: null,
                email: null,
                unique_id: null,
                color: "#dc3545",
                password: null,
                confirm_password: null,
                role: {
                    id: '',
                    name: ''
                },
                assigned_projects: []
            };
            this.createUserStep = 1;

        },
        lastUpdated(user) {
            return moment.utc(user.updated_at).fromNow();
        },
        projectChange(event, project) {
            if (event.target.checked) {
                this.currentUser.assigned_projects.push(project);
            } else {
                this.currentUser.assigned_projects = this.currentUser.assigned_projects.filter(function (obj) {
                    return obj.id !== project.id;
                });
            }
        },
        saveUser(event) {
            event.preventDefault();

            this.errors = [];

            if (!this.currentUser.name) {
                this.errors.push("Name required.");
            }

            if (!this.currentUser.email) {
                this.errors.push("Email  required.");
            } else if (!this.validEmail(this.currentUser.email)) {
                this.errors.push('Valid email required.');
            }

            if (!this.currentUser.role.id) {
                this.errors.push("Role required.");
            }

            if (!this.currentUser.id) {
                if (!this.currentUser.password) {
                    this.errors.push("Password  required.");
                }
                if (!this.currentUser.confirm_password) {
                    this.errors.push("Password confirmation required.");
                }
            }

            if (this.currentUser.password !== this.currentUser.confirm_password) {
                this.errors.push("Passwords don't match.");
            }


            if (this.currentUser.password) {
                const lowerCaseLetters = /[a-z]/g;
                const upperCaseLetters = /[A-Z]/g;
                const numbers = /[0-9]/g;

                if (this.currentUser.password.length < 8 || !this.currentUser.password.match(lowerCaseLetters)
                    || !this.currentUser.password.match(upperCaseLetters) || !this.currentUser.password.match(numbers)) {
                    this.errors.push("The password must be at least 8 characters long, must contain both lower- and uppercase letters and numbers.");
                }

            }


            if (!this.errors.length) {
                const token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/users',
                    data: this.currentUser,
                    method: 'POST',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.$bvModal.hide('userModal');
                        this.load();
                    })
                    .catch((error) => {
                        if (error.response && error.response.data && error.response.data.errors) {

                            for (const [key, value] of Object.entries(error.response.data.errors)) {
                                this.errors.push(value);
                                console.log(`${key}: ${value}`);
                            }
                        }
                        console.log(error, 'err');
                    });
            }

        },
        closeEditUserModal() {
            this.resetCurrentUser();
            this.load();
            this.$bvModal.hide('userModal');
        },
        validEmail: function (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        canEdit(user) {
            if (this.hasManagerPermission('projects.add_user')) {
                const ownRoleId = this.$store.state.project.user.role;

                // Admins can always edit other admins.
                if (user.role.id === 1) {
                    return ownRoleId === 1;
                }

                // User can only edit accounts with less powerful roles.
                return user.role.id > ownRoleId;
            }

            return false;
        },
        canDelete(user) {
            if (this.hasManagerPermission('projects.delete_user')) {
                const ownRoleId = this.$store.state.project.user.role;

                // User cannot delete his/her own account.
                if (user.id === this.$store.state.user.id) {
                    return false;
                }

                // Admins can always delete other admins.
                if (user.role.id === 1) {
                    return ownRoleId === 1;
                }

                // User can only delete accounts with less powerful roles.
                return user.role.id > ownRoleId;
            }

            return false;
        }
    },
    watch: {}

}
</script>

<style scoped>
.last-updated {
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 4px;
    cursor: default;
}
</style>
